/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) 2020 Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  successfullyLoggedIn: 'Du är inloggad!',
  failedToLogIn: 'Någonting gick fel vid inloggningen, vänligen försök igen.',
  successfullyLoggedOut: 'Du är utloggad!',
  failedToLogOut: 'Någonting gick fel vid utloggningen, vänligen försök igen.',
  successfullyRecoveredPassword: 'Ditt lösenord har återställts! Kontrollera din e-post för vidare instruktioner.',
  failedToRecoverPassword: 'Någonting gick fel vid återställningen av ditt lösenord, vänligen försök igen.',
  invalidateSuccess: 'Cachen har rensats.',
  sessionExpired: 'Din session har upphört att gälla, vänligen logga in igen.',
}
